export const riskProfileDonotWish =
  'I do not wish to undergo the RISK Profiling and want to use the platform of products and services as execution only platform, whereby all investment decisions would be my sole discretion and decision';

export const riskProfileDeclaration =
  'I/We hereby submit that I/We will immediately inform MOAMC in case I/We am/are convicted under any grounds or any action is taken against me/us by any other authority';

export const fatcaTinDeclaration = `I am not entitled to have TIN / Residing Country does not issue TIN because of the following reasons and hereby submit the relevant documentary proof (self-attested) as indicated. [Tick relevant documentary proof and indicated the document type]`;

export const fatcaDeclaration1 =
  'In case of U.S. persons where Nationality and Country of Birth is U.S. but tax residency is of other country , any one of the following documents duly self-attested should be submitted: ';

export const fatcaDeclaration2 = `• Non-US Passport or any non-US government issued document evidencing nationality or citizenship; AND `;
export const fatcaDeclaration3 =
  '• Certified Copy of Certificate of loss of US Nationality/ Reasonable explanation for non obtaining such certificate';
